export class SidebarMenuItem {
  constructor(initData?: Partial<SidebarMenuItem>) {
    if (initData) {
      Object.assign(this, initData);
    }
  }

  public icon: string;
  public name = '';
  public disableCollapse = false;
  public label: string;
  public style: { transform: string };

  public hidden: () => boolean = () => false;
  public isActive: () => boolean = () => false;
  public action: () => void = () => {
    throw new Error(`Action requested: ${this.name}`);
  };
}
